import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout.component';

export const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: '',
                loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent)
            },
            {
                path: 'motivo',
                loadComponent: () => import('./features/reason/reason.component').then(m => m.ReasonComponent)
            },
            {
                path: 'soluciones',
                loadComponent: () => import('./features/solutions/solutions.component').then(m => m.SolutionsComponent)
            },
            {
                path: 'metodologia',
                loadComponent: () => import('./features/methodology/methodology.component').then(m => m.MethodologyComponent)
            }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
